import React, { useEffect, useState, useMemo } from "react";
import { Configuration, Props } from "./models/models";
import DesignTokens from "@cheshire-datasystems/designtokens";
import { ConfigContext } from "./models/ConfigContext";
import { AppBuilders, UIKit } from "@cheshire-datasystems/toren-utilities";

const Root = (props: Props) => {
  const structure = props.mfeConfigs[Configuration.Structure];
  const [layoutConfig, setLayoutConfig] = useState(structure);
  const [tokenConfig, setTokenConfig] = useState(DesignTokens);
  const [store, setStore] = useState(null);

  const contextValue = useMemo(
    () => ({
      layoutConfig,
      setLayoutConfig,
      allLayouts: {
        defaultLayout: layoutConfig,
      },
    }),
    [layoutConfig]
  );

  return (
    <ConfigContext.Provider value={contextValue}>
      <UIKit.ThemeProvider
        theme={{
          tokens: tokenConfig,
        }}
      >
        <AppBuilders
          config={layoutConfig}
          siteConfig={contextValue}
          actions={{}}
          initialState={{}}
          //@ts-ignore
          slices={{}}
          onStoreReady={setStore}
        />
      </UIKit.ThemeProvider>
    </ConfigContext.Provider>
  );
};

export default Root;
